import React, { useState } from "react";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import { Link } from "react-router-dom";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import SettingsLinks from "../settingsLinks/settingsLinks";
import SettingsModal from "../settingsModal/settingsModal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { User } from "../../../../core/types/types";
import { updateUser } from "../../../../core/redux/authSlice";
import CustomSelect from "../../../../core/common/commonSelect";
import { Country, GradingScheme, LevelOfEducation } from "../../../../core/common/selectOption/json/selectOption";
import apiInstance from "../../../../utility/apiInstance";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const gradeSchemeProps = (scheme: string) => {
    if (scheme === 'percentage') {
        return { min: 0, max: 100, step: 0.01, placeholder: '0.00 – 100.00' };
    }
    // default: grade10 (0–10 scale)
    return { min: 0, max: 10, step: 0.01, placeholder: '0.00 – 10.00' };
};

const StudentEducationHistory = () => {

    const user = useSelector((state: any) => state.auth.user);
    const dispatch = useDispatch();

    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

    const [errorField, setErrorField] = useState('');

    const educationHistory = user?.educationHistory;
    const highestEducation = educationHistory?.highestEducation;
    const schoolsAttended = educationHistory?.schoolsAttended;

    const [formData, setFormData] = useState<User>({
        id: user?.id || '',
        educationHistory: {
            highestEducation: {
                country: highestEducation?.country || 'AF',
                level: highestEducation?.level || 'ugDiploma',
                gradingScheme: highestEducation?.gradingScheme || 'grade10',
                gradeAverage: highestEducation?.gradeAverage || '',
                isGraduated: highestEducation?.isGraduated || 'yes'
            },
            schoolsAttended: schoolsAttended || []
        }
    })

    const getModalContainer = () => {
        const modalElement = document.getElementById("add_assignment");
        return modalElement ? modalElement : document.body;
    };

    const handleHigestEducationChange = (e: React.ChangeEvent<HTMLInputElement> | any) => {
        setFormData({
            ...formData,
            educationHistory: {
                ...formData.educationHistory,
                highestEducation: {
                    ...(formData.educationHistory?.highestEducation ?? {
                        country: 'AF',
                        level: 'ugDiploma',
                        gradingScheme: 'grade10',
                        gradeAverage: 0,
                        isGraduated: 'yes'
                    }),
                    [e.target.name]: e.target.value
                }
            }
        });
        if (errorField === e.target.name) setErrorField('');
    }

    const validate = () => {
        let newErrors = '';
        let invalidField = '';

        if (!formData.educationHistory?.highestEducation?.country.trim()) {
            newErrors = "Highest education country is required";
            invalidField = 'country';
        } else if (!formData.educationHistory?.highestEducation?.level.trim()) {
            newErrors = "Highest education level is required";
            invalidField = 'level';
        } else if (!formData.educationHistory?.highestEducation?.gradingScheme.trim()) {
            newErrors = "Highest education grading scheme is required";
            invalidField = 'gradingScheme';
        } else if (!formData.educationHistory?.highestEducation?.gradeAverage) {
            newErrors = "Highest education grade average is required";
            invalidField = 'gradeAverage';
        }

        setErrorField(invalidField);

        setMsg({
            error: true,
            loading: false,
            text: newErrors
        })

        return newErrors.length === 0
    };

    const updateProfile = async (e: any) => {
        e.preventDefault();

        if (!validate()) return;

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/users/${formData.id}`, formData)
            dispatch(updateUser(response.data.doc))
            setMsg({
                error: false,
                loading: false,
                text: 'Details updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    const addAttendedSchool = () => {
        setFormData({
            ...formData,
            educationHistory: {
                ...formData.educationHistory,
                schoolsAttended: [
                    ...(formData.educationHistory?.schoolsAttended ?? []),
                    {
                        country: 'AF',
                        institution: '',
                        level: 'ugDiploma',
                        gradingScheme: 'grade10',
                        gradeAverage: 0,
                        degreeName: '',
                        from: '',
                        to: '',
                        isGraduated: 'yes'
                    }
                ]
            }
        });
    }

    const updateAttendedSchool = (index: number, data: any) => {
        const updatedSchools = formData.educationHistory?.schoolsAttended?.map((school, i) => {
            if (i === index) {
                return {
                    ...school,
                    [data.name]: data.value
                };
            } else {
                return school;
            }
        });

        setFormData({
            ...formData,
            educationHistory: {
                ...formData.educationHistory,
                schoolsAttended: updatedSchools
            }
        });

    }

    const deleteAttendedSchool = (index: number) => {
        const updatedSchools = formData.educationHistory?.schoolsAttended?.filter((_, i) => i !== index);
        setFormData({
            ...formData,
            educationHistory: {
                ...formData.educationHistory,
                schoolsAttended: updatedSchools
            }
        });
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* Profile */}
                    <ProfileCard />
                    {/* /Profile */}
                    <div className="row">
                        {/* Sidebar */}
                        <StudentSidebar />
                        {/* Sidebar */}
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <div className="card">
                                <div className="card-body">

                                    <div>
                                        <div className="edit-profile-info mb-3">
                                            <h5 className="mb-1">Highest Education</h5>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Country <span className="text-danger"> *</span>
                                                    </label>
                                                    <CustomSelect
                                                        options={Country}
                                                        className={`select d-flex ${errorField === 'country' ? 'is-invalid' : ''}`}
                                                        placeholder="Select"
                                                        name="country"
                                                        value={formData?.educationHistory?.highestEducation?.country || ''}
                                                        onChange={(selectedOption) => {
                                                            handleHigestEducationChange({
                                                                target: {
                                                                    name: 'country',
                                                                    value: selectedOption.value
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    {errorField === 'country' && (
                                                        <div className="invalid-feedback d-block">{msg.text}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Level of Education <span className="text-danger"> *</span>
                                                    </label>
                                                    <CustomSelect
                                                        options={LevelOfEducation}
                                                        className={`select d-flex ${errorField === 'level' ? 'is-invalid' : ''}`}
                                                        placeholder="Select"
                                                        name="level"
                                                        value={formData?.educationHistory?.highestEducation?.level || ''}
                                                        onChange={(selectedOption) => {
                                                            handleHigestEducationChange({
                                                                target: {
                                                                    name: 'level',
                                                                    value: selectedOption.value
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    {errorField === 'level' && (
                                                        <div className="invalid-feedback d-block">{msg.text}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Grading Scheme <span className="text-danger"> *</span>
                                                    </label>
                                                    <CustomSelect
                                                        options={GradingScheme}
                                                        className={`select d-flex ${errorField === 'gradingScheme' ? 'is-invalid' : ''}`}
                                                        placeholder="Select"
                                                        name="gradingScheme"
                                                        value={formData?.educationHistory?.highestEducation?.gradingScheme || ''}
                                                        onChange={(selectedOption) => {
                                                            handleHigestEducationChange({
                                                                target: {
                                                                    name: 'gradingScheme',
                                                                    value: selectedOption.value
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    {errorField === 'gradingScheme' && (
                                                        <div className="invalid-feedback d-block">{msg.text}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Grade Average <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        className={`form-control ${errorField === 'gradeAverage' ? 'is-invalid' : ''}`}
                                                        name="gradeAverage"
                                                        value={formData?.educationHistory?.highestEducation?.gradeAverage || ''}
                                                        onChange={(e) => {
                                                            const raw = e.target.value;
                                                            const decimalMatch = raw.split('.');
                                                            if (decimalMatch[1] && decimalMatch[1].length > 2) return;
                                                            const scheme = formData?.educationHistory?.highestEducation?.gradingScheme || 'grade10';
                                                            const { max } = gradeSchemeProps(scheme);
                                                            const val = parseFloat(raw);
                                                            if (!isNaN(val) && val > max) return;
                                                            handleHigestEducationChange(e);
                                                        }}
                                                        {...gradeSchemeProps(formData?.educationHistory?.highestEducation?.gradingScheme || 'grade10')}
                                                    />
                                                    {errorField === 'gradeAverage' && (
                                                        <div className="invalid-feedback d-block">{msg.text}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Graduated from this institution?
                                                    </label>
                                                    <CustomSelect
                                                        options={[
                                                            { label: 'Yes', value: 'yes' },
                                                            { label: 'No', value: 'no' },
                                                        ]}
                                                        className="select d-flex"
                                                        placeholder="Select"
                                                        name="isGraduated"
                                                        value={formData?.educationHistory?.highestEducation?.isGraduated || ''}
                                                        onChange={(selectedOption) => {
                                                            handleHigestEducationChange({
                                                                target: {
                                                                    name: 'isGraduated',
                                                                    value: selectedOption.value
                                                                }
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <div>
                                        <div className="edit-profile-info mb-3">
                                            <h5 className="mb-1">Attended Schools</h5>
                                        </div>


                                        {formData.educationHistory?.schoolsAttended?.length ? (
                                            formData.educationHistory?.schoolsAttended?.map((school, index) => (

                                                <div key={index} className="card">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="d-flex justify-content-end mt-3">
                                                                <i className="cursor-pointer isax isax-trash text-danger" onClick={() => deleteAttendedSchool(index)}></i>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Country
                                                                    </label>
                                                                    <CustomSelect
                                                                        options={Country}
                                                                        className="select d-flex"
                                                                        placeholder="Select"
                                                                        name="country"
                                                                        value={school.country || ''}
                                                                        onChange={(selectedOption) => {
                                                                            updateAttendedSchool(index, {
                                                                                name: 'country',
                                                                                value: selectedOption.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Institution Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        defaultValue=""
                                                                        name="institution"
                                                                        value={school.institution || ''}
                                                                        onChange={(e) => {
                                                                            updateAttendedSchool(index, {
                                                                                name: e.target.name,
                                                                                value: e.target.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Level of Education
                                                                    </label>
                                                                    <CustomSelect
                                                                        options={LevelOfEducation}
                                                                        className="select d-flex"
                                                                        placeholder="Select"
                                                                        name="level"
                                                                        value={school.level || ''}
                                                                        onChange={(selectedOption) => {
                                                                            updateAttendedSchool(index, {
                                                                                name: 'level',
                                                                                value: selectedOption.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Grading Scheme
                                                                    </label>
                                                                    <CustomSelect
                                                                        options={GradingScheme}
                                                                        className="select d-flex"
                                                                        placeholder="Select"
                                                                        name="gradingScheme"
                                                                        value={school.gradingScheme || ''}
                                                                        onChange={(selectedOption) => {
                                                                            updateAttendedSchool(index, {
                                                                                name: 'gradingScheme',
                                                                                value: selectedOption.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Grade Average
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        name="gradeAverage"
                                                                        value={school.gradeAverage || ''}
                                                                        onChange={(e) => {
                                                                            const raw = e.target.value;
                                                                            const decimalMatch = raw.split('.');
                                                                            if (decimalMatch[1] && decimalMatch[1].length > 2) return;
                                                                            const scheme = school.gradingScheme || 'grade10';
                                                                            const { max } = gradeSchemeProps(scheme);
                                                                            const val = parseFloat(raw);
                                                                            if (!isNaN(val) && val > max) return;
                                                                            updateAttendedSchool(index, {
                                                                                name: e.target.name,
                                                                                value: raw
                                                                            });
                                                                        }}
                                                                        {...gradeSchemeProps(school.gradingScheme || 'grade10')}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Degree Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        defaultValue=""
                                                                        name="degreeName"
                                                                        value={school.degreeName || ''}
                                                                        onChange={(e) => {
                                                                            updateAttendedSchool(index, {
                                                                                name: e.target.name,
                                                                                value: e.target.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Attended From
                                                                    </label>
                                                                    <div className="input-icon-start position-relative">
                                                                        <span className="input-icon-addon">
                                                                            <i className="isax isax-calendar" />
                                                                        </span>

                                                                        <DatePicker
                                                                            name="from"
                                                                            className="form-control datetimepicker"
                                                                            getPopupContainer={getModalContainer}
                                                                            placeholder="Select Date"
                                                                            format="DD/MM/YYYY"
                                                                            onChange={(date) => {
                                                                                updateAttendedSchool(index, {
                                                                                    name: 'from',
                                                                                    value: date ? date.format('YYYY-MM-DD') : ''
                                                                                });
                                                                            }}
                                                                            value={school.from ? dayjs(school.from) : null}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Attended To
                                                                    </label>
                                                                    <div className="input-icon-start position-relative">
                                                                        <span className="input-icon-addon">
                                                                            <i className="isax isax-calendar" />
                                                                        </span>

                                                                        <DatePicker
                                                                            name="to"
                                                                            className="form-control datetimepicker"
                                                                            getPopupContainer={getModalContainer}
                                                                            placeholder="Select Date"
                                                                            format="DD/MM/YYYY"
                                                                            onChange={(date) => {
                                                                                updateAttendedSchool(index, {
                                                                                    name: 'to',
                                                                                    value: date ? date.format('YYYY-MM-DD') : ''
                                                                                });
                                                                            }}
                                                                            value={school.to ? dayjs(school.to) : null}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">
                                                                        Graduated from this institution?
                                                                    </label>
                                                                    <CustomSelect
                                                                        options={[
                                                                            { label: 'Yes', value: 'yes' },
                                                                            { label: 'No', value: 'no' },
                                                                        ]}
                                                                        className="select d-flex"
                                                                        placeholder="Select"
                                                                        name="isGraduated"
                                                                        value={school.isGraduated || ''}
                                                                        onChange={(selectedOption) => {
                                                                            updateAttendedSchool(index, {
                                                                                name: 'isGraduated',
                                                                                value: selectedOption.value
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            ))
                                        ) : (
                                            <p>No schools attended added yet.</p>
                                        )}


                                        <div className="d-flex justify-content-end mt-3">
                                            <button
                                                className="btn btn-outline-secondary rounded-pill"
                                                type="submit"
                                                onClick={addAttendedSchool}
                                            >
                                                Add School
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button
                                    className="btn btn-secondary rounded-pill"
                                    type="submit"
                                    onClick={updateProfile}
                                >
                                    Save
                                </button>
                                {msg.loading &&
                                    <span className="mt-3 fs-14 fw-normal d-flex align-items-center justify-content-center">Updating details...</span>
                                }
                                {!msg.loading && !errorField &&
                                    <span className={`mt-3 ${msg.error ? 'text-red' : ''} fs-14 fw-normal d-flex align-items-center justify-content-center`}>{msg.text}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SettingsModal />
        </>
    );
};

export default StudentEducationHistory;
